import {get} from 'lodash-es';
import {createSelector} from 'reselect';

import {getUser} from 'static/three-oh/src/modules/selectors/userSelectors';


const getImpersonatedUser = (state) => get(state, 'binderImpersonatedUser', null);


// Returns the effective binder user. This is typically the user who is currently logged in, but principals and district
// administrators may access other teacher's binders via user impersonation.
const getAuthenticatedOrImpersonatedUser = createSelector(
  [
    getUser,
    getImpersonatedUser
  ],
  (authenticatedUser, impersonatedUser) => {
    if (impersonatedUser) {
      return {...impersonatedUser, isImpersonated: true};
    } else if (authenticatedUser) {
      return {...authenticatedUser, isImpersonated: false};
    }
    return null;
  }
);

const initialBinderDataIsPresent = (state) => {
  const classroomsFinishedLoading = get(state, 'classrooms.dateLoaded');

  return Boolean(
    classroomsFinishedLoading
  );
};


const initialBinderDataHasError = (state) => {
  const impersonationError = get(getImpersonatedUser(state), 'isError', false);
  const classroomError = get(state, 'classrooms.error');
  return impersonationError || !!classroomError;
};

export {
  getAuthenticatedOrImpersonatedUser,
  getImpersonatedUser,
  initialBinderDataIsPresent,
  initialBinderDataHasError,
};
